import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import client from './client';
var apiBasePath = '/taxonomy/taxonomy';
export var getTaxonomyTerms = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(taxonomyName, taxonomyTerm, maxDepth) {
    var apiError;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.get("".concat(apiBasePath, "/").concat(taxonomyName), _objectSpread(_objectSpread({}, taxonomyTerm === undefined ? {} : {
              taxonomyTerm: taxonomyTerm
            }), maxDepth === undefined ? {} : {
              maxDepth: maxDepth
            }));

          case 3:
            return _context.abrupt("return", _context.sent);

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            apiError = _context.t0;

            if ((apiError === null || apiError === void 0 ? void 0 : apiError.code) !== '404') {
              console.error('Error while retrieving page linked of the internal link', _context.t0);
            }

            return _context.abrupt("return", []);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));

  return function getTaxonomyTerms(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var getTaxonomyTerm = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var termId, includeChildren, includeChildrenWithCount, apiError;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            termId = _ref2.termId, includeChildren = _ref2.includeChildren, includeChildrenWithCount = _ref2.includeChildrenWithCount;
            _context2.prev = 1;
            return _context2.abrupt("return", client.get("".concat(apiBasePath, "/term/").concat(termId), {
              includeChildren: includeChildren,
              includeChildrenWithCount: includeChildrenWithCount
            }));

          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](1);
            apiError = _context2.t0;

            if ((apiError === null || apiError === void 0 ? void 0 : apiError.code) !== '404') {
              console.error('Error while retrieving page linked of the internal link', _context2.t0);
            }

            return _context2.abrupt("return", undefined);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 5]]);
  }));

  return function getTaxonomyTerm(_x4) {
    return _ref3.apply(this, arguments);
  };
}();